<template>
   <div>
      <v-app
         id="inspire"
         transition="slide-x-transition"
         v-if="loggedUser && loggedLocal"
      >
         <!-- /*<drawer-menu v-bind:drawer="drawer"></drawer-menu>*/ -->
         <drawer-menu ref="drawerMenu" @loggout="init"></drawer-menu>


         <v-toolbar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="primary"
            class="elevation-4 white--text font-weight-medium toolbarBorder"
            dark
            app
            fixed
         >
            <v-toolbar-side-icon
               class="white--text font-weight-light"
               @click.stop="changeDrawerMenu"
            >
               <v-icon>menu</v-icon>
            </v-toolbar-side-icon>
            <div style="float:right;width:7%;margin:6px">
               <img style="width:100%;height:100%" src="./images/logo-light-horizontal.png" />
            </div>
            <v-spacer></v-spacer>
            <v-toolbar-items style="width:40%" :class="$vuetify.breakpoint.mdOnly ? 'mt-5' : ''">
               <v-layout row wrap algin-center>
                  <v-flex xs12>
                     <v-overflow-btn
                        auto-select-first
                        background-color="transparent"
                        v-model="company"
                        :items="companies"
                        @change="selectCompany"
                        label="Empresa Atual"
                        :item-text="companyText"
                        item-value="_id"
                        target="#dropdown-example"
                        no-data-text="Nenhuma Empresa Habilitada"
                        hide-selected
                     ></v-overflow-btn>
                  </v-flex>
               </v-layout>
            </v-toolbar-items>
         </v-toolbar>
         <v-content v-if="isUnauthorized">
            <v-container fluid>
               <v-layout row wrap justify-center align-center>
                  <v-flex xs12 class="text-xs-center mt-5">
                     <img style="width:5%" src="./images/block-user.svg"/>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">
                     <span class="subtitle">Acesso não autorizado</span>
                  </v-flex>
               </v-layout>
            </v-container>
         </v-content>
            <v-content v-else>
               <v-container fluid style="background-color: #F5F5F5;">
                  <router-view></router-view>
               </v-container>
            </v-content>
      </v-app>

      <v-app v-else>
         <v-content class="bg-image">
            <v-container fluid fill-height>
               <form-login @userIsLogged="setCompanies"></form-login>
            </v-container>
         </v-content>
      </v-app>
   </div>
</template>

<script>
import DrawerMenu from '@/components/DrawerMenu'
import AlertBar from '@/components/AlertBar'
import FormLogin from '@/components/FormLogin'
import UserService from '@/service/UserService'
import AppEvents from '@/events'

export default {
   components: {
      DrawerMenu,
      FormLogin,
      AlertBar,
   },

   data: () => ({
      companyName: 'BrilharMS',
      user: {
         access: [],
      },
      loggedLocal: false,
      home: '/',
      company: {},
      companies: [],
      drawer: false,
      drawerOpen: false,
      isEditing: null,
   }),
   computed: {
      loggedUser() {
         return this.$store.getters.getStateLog
      },
      isUnauthorized() {
         return this.$route.path == '/unauthorized' ? true : false
      },
   },

   methods: {
      goToHome() {
         this.$router.push('/')
      },
      changeDrawerMenu() {
         if (this.drawerOpen == true)
            window.getApp.$emit('CLOSE_DRAWER_MENU'), (this.drawerOpen = false)
         else if (this.drawerOpen == false)
            window.getApp.$emit('OPEN_DRAWER_MENU'), (this.drawerOpen = true)
      },
      selectCompany() {
         this.$refs.drawerMenu.loadAccess(this.company);
         this.containsEntities()
      },
      setCompanies() {
         if (this.$store.getters.getCompany) {
            this.company = this.$store.getters.getCompany
         }
         let user = this.$store.getters.getUserLogged
         this.loggedLocal = true
         for (let index = 0; index < user.access.length; index++) {
            const element = user.access[index]
            this.companies.push(user.access[index].company)
         }
      },
      containsEntities() {
         if (this.$store.getters.getStateLog) {
            let entities = this.$store.getters.getEntities
            let path     = this.$route.meta.access;
            if (!entities.includes(path) && this.$route.path!='/') {
               this.$router.push('/unauthorized')
            }
         }
      },
      init() {
         this.companies = []
         this.company = {}
         this.loggedLocal = false
      },

      companyText: item => `${item.socialName} - ${item.fantasyName}`,
   },
   beforeMount() {
      if (localStorage.getItem('loggedUser')) {
         this.loggedLocal = true
      }
   },
   mounted() {
      this.$store.dispatch('loadLoggedUser')
      this.setCompanies()
   },

   async beforeMount() {
      AppEvents.forEach(item => {
         this.$on(item.name, item.callback)
      })
   },

   created() {
      window.getApp = this
   },

   props: {
      source: String,
   },
}
</script>

<style scoped>
.bg-image {
   background-image: url('assets/background.png');
   background-position: center;
   background-size: 100%;
}

.toolbarBorder {
   border-bottom: 5px #64b5f6 !important;
}

.theme--dark.v-overflow-btn.v-input--is-focused .v-input__slot,
.theme--dark.v-overflow-btn.v-select--is-menu-active .v-input__slot,
.theme--dark.v-overflow-btn:hover .v-input__slot {
   background: transparent !important;
}

.card-unauthorized {
   background-color: rgba(255, 255, 255, 0.8);
   border-radius: 10px;
   padding: 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue